enum GUEST_PAGE_KEY {
  /* 登入頁面 */
  SIGN_IN = 'SignIn'
}

export default GUEST_PAGE_KEY;
